import { render, staticRenderFns } from "./AdminUserCreate.vue?vue&type=template&id=56951cea&"
import script from "./AdminUserCreate.vue?vue&type=script&lang=js&"
export * from "./AdminUserCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports